// Lightweight “Buy It Now / Checkout” behaviour shared across product forms.
// Uses event delegation so buttons inside dynamically loaded modals (quick add)
// work without re-binding after AJAX content loads.

const BUY_NOW_SELECTOR = '[data-hdt-buy-now]';

function findProductForm(button) {
  const formId = button.getAttribute('data-hdt-buy-now-form');
  if (formId) {
    const byId = document.getElementById(formId);
    if (byId) return byId;
  }
  return button.closest('form');
}

function getVariantId(form) {
  const idInput = form.querySelector('input[name="id"]');
  if (idInput?.value) return idInput.value;
  return new FormData(form).get('id');
}

function getQuantity(form) {
  const quantityInput = form.querySelector('input[name="quantity"]');
  if (quantityInput?.value) {
    const parsed = parseInt(quantityInput.value, 10);
    if (parsed > 0) return parsed;
  }
  const fromFormData = new FormData(form).get('quantity');
  return fromFormData ? parseInt(fromFormData, 10) || 1 : 1;
}

function getProductUrl(form) {
  const scope =
    form.closest('.hdt-main-product-quick-add, .hdt-main-product, wrapp-hdt-pr-frm') ||
    form.parentElement;
  if (!scope) return null;

  const variantPicker = scope.querySelector('hdt-variant-picker[handle]');
  if (variantPicker) {
    const handle = variantPicker.getAttribute('handle');
    if (handle) {
      const root = window.Shopify?.routes?.root || '/';
      return `${root}products/${handle}`;
    }
  }

  const productLink = scope.querySelector('.hdt-product__title a[href], a[data-pr-url][href]');
  if (productLink) return productLink.href;

  return null;
}

async function handleBuyNowClick(button) {
  if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

  const form = findProductForm(button);
  if (!form) return;

  const submitButton = form.querySelector('button[type="submit"][name="add"]');
  if (submitButton?.disabled) return;

  const variantId = getVariantId(form);
  if (!variantId) {
    const productUrl = getProductUrl(form);
    if (productUrl) {
      window.location.href = productUrl;
    } else {
      form.submit();
    }
    return;
  }

  const quantity = getQuantity(form);
  const root = window.Shopify?.routes?.root || '/';

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error('Add to cart failed');
    }

    window.location.href = `${root}checkout`;
  } catch (e) {
    // Fallback – regular form submit with return_to so Shopify redirects.
    let returnInput = form.querySelector('input[name="return_to"]');
    if (!returnInput) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      form.appendChild(returnInput);
    }
    returnInput.value = `${root}checkout`;

    const idInput = form.querySelector('input[name="id"]');
    if (idInput?.disabled) {
      idInput.disabled = false;
    }

    form.submit();
  } finally {
    button.removeAttribute('aria-busy');
    button.disabled = false;
  }
}

function initBuyNow() {
  if (initBuyNow.initialized) return;
  initBuyNow.initialized = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest(BUY_NOW_SELECTOR);
    if (!button) return;

    event.preventDefault();
    handleBuyNowClick(button);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBuyNow);
} else {
  initBuyNow();
}

document.addEventListener('shopify:section:load', initBuyNow);
